import { cn } from '@1trading/react/lib/utils';
import React from 'react';

const PersonalInformationFormFields = React.forwardRef<HTMLDivElement, React.HTMLAttributes<HTMLDivElement>>(({ children, className, ...props }, ref) => {
  return (
    <div ref={ref} className={cn('grid grid-cols-2 gap-x-4 gap-y-6 border-b pb-6 last-of-type:border-b-0 last-of-type:pb-0', className)} {...props}>
      {children}
    </div>
  );
});
PersonalInformationFormFields.displayName = 'PersonalInformationFormFields';

export default PersonalInformationFormFields;
